import ClearModal from './ClearModal';

export default ClearModal;
